import { render } from "./Breakfast.vue?vue&type=template&id=7a649b10&scoped=true"
import script from "./Breakfast.vue?vue&type=script&lang=js"
export * from "./Breakfast.vue?vue&type=script&lang=js"

import "./Breakfast.vue?vue&type=style&index=0&id=7a649b10&lang=css"
import "./Breakfast.vue?vue&type=style&index=1&id=7a649b10&lang=css"
import "./Breakfast.vue?vue&type=style&index=2&id=7a649b10&scoped=true&lang=css"
import "./Breakfast.vue?vue&type=style&index=3&id=7a649b10&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a649b10"]])

export default __exports__